import { UntypedFormControl } from '@angular/forms';

export function dunsNumberValidator(control: UntypedFormControl) {
    if (control.value.includes('-')) {
        return { dunsNumberValid: false };
    }
    return null;
}
